import { useAuthStore } from '@/stores'
import axios from 'axios'

const isProduction = import.meta.env.MODE === 'production'
const baseURL = isProduction ? 'https://aptisuksestama.co.id/api/' : 'http://127.0.0.1:8000/api/'

const $axios = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})

$axios.interceptors.request.use(
  function (config) {
    const token = useAuthStore().token
    if (token) config.headers.Authorization = `Bearer ${token}`
    return config
  },
  function (error) {
    return Promise.reject(error)
  },
)
export default $axios
